import { render, staticRenderFns } from "./message-view-hero.vue?vue&type=template&id=13671966&scoped=true"
import script from "./message-view-hero.vue?vue&type=script&lang=js"
export * from "./message-view-hero.vue?vue&type=script&lang=js"
import style0 from "./message-view-hero.vue?vue&type=style&index=0&id=13671966&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13671966",
  null
  
)

export default component.exports